import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Button,
  InputAdornment,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import CustomerListModal from "./modal/member_modal";
import * as services from "./../../services/customer";
import * as productServices from "./../../services/saleng";
import { NumericFormat } from "react-number-format";

export default function GroupEditPage() {
  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(true);
  const [groupDetail, setGroupDetail] = useState("");
  const [customers, setCustomers] = useState([]);
  const { group_id } = useParams();
  const [modalOpen, setModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [rowModesModel, setRowModesModel] = useState({});

  const filteredProducts = products.filter(
    (p) =>
      p.title.toLowerCase().includes(productSearch.toLowerCase()) ||
      p.category.includes(productSearch) ||
      p.subCategory.includes(productSearch)
  );
  useEffect(() => {
    fetchCustomerbyGroup();
    fetchProduct();
  }, []);
  const fetchCustomerbyGroup = async () => {
    try {
      let res = await services.getCustomerByGroup(group_id);
      const rawData = res.data?.data || [];
      setGroupName(rawData.name);
      setGroupDetail(rawData.detail);
      setCustomers(rawData.customers);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchProduct = async () => {
    const res = await productServices.getProducts();
    const products = res.data.data;
    const adjRes = await productServices.getProductGroupsAdjustments(group_id);
    const adjustments = adjRes.data.data;
    const productsWithIndex = products.map((item, index) => {
      const adjItem = adjustments.find((a) => a.productId === item.id);
      const adjustment = adjItem?.adjustment ?? 0;
      return {
        ...item,
        no: index + 1,
        category: item.category.name,
        subCategory: item.subCategory.name,
        adjustment,
        total: (item.price ?? 0) + adjustment,
        adjItem: !!adjItem,
      };
    });
    setProducts(productsWithIndex);
  };
  const handleRemoveCustomer = async (customerId) => {
    try {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        title: "ยืนยันที่จะแก้ไขข้อมูล?",
        text: "คุณจะไม่สามารถย้อนกลับสิ่งนี้ได้!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await services.updateCustomeGroup({
            customerId: customerId,
          });
          setCustomers((prev) => prev.filter((c) => c.id !== customerId));
          toast.success(`ลบข้อมูลสำเร็จ!`);
        }
      });
    } catch (error) {
      console.error("Error removing customer:", error);
      alert("เกิดข้อผิดพลาดขณะลบซัพพลายเออร์");
    }
  };

  const closeModal = async () => {
    try {
      setModalOpen(false);
      fetchCustomerbyGroup();
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={2}>
      <Toaster position="bottom-right" reverseOrder={false} />
      <AppBreadcrumbs />
      <CustomerListModal
        open={modalOpen}
        onClose={() => closeModal()}
        groupId={group_id}
      />
      <Grid container spacing={2}>
        {/* ฝั่งซ้าย */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "85vh", // หรือปรับความสูงที่ต้องการ
              pb: 2,
            }}
          >
            <Typography variant="h5" sx={{ my: 2 }}>
              ข้อมูลกลุ่ม
            </Typography>
            <TextField
              label="ชื่อกลุ่ม"
              fullWidth
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              sx={{ mb: 2 }}
              disabled
            />

            <TextField
              label="รายละเอียด"
              fullWidth
              multiline
              rows={2}
              value={groupDetail}
              onChange={(e) => setGroupDetail(e.target.value)}
              sx={{ mb: 2 }}
              disabled
            />

            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextField
                placeholder="พิมพ์เพื่อค้นหาซัพพลายเออร์"
                size="small"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                size="small"
                sx={{ whiteSpace: "nowrap" }}
                onClick={() => setModalOpen(true)}
              >
                เพิ่มซัพพลายเออร์
              </Button>
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", mb: 2 }}>
              <List dense>
                {customers.map((c) => (
                  <ListItem
                    key={c.id}
                    secondaryAction={
                      <IconButton
                        edge="end"
                        onClick={() => handleRemoveCustomer(c.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar />
                    </ListItemAvatar>
                    <ListItemText
                      primary={c.name}
                      secondary={
                        c.personType === "normal" ? "บุคคลธรรมดา" : "นิติบุคคล"
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>

            <Divider />

            <Button
              fullWidth
              variant="contained"
              color="success"
              sx={{ mt: "auto" }}
            >
              บันทึก
            </Button>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          mt={5.5}
          sx={{ height: "calc(90vh - 150px)" }}
        >
          <TextField
            fullWidth
            placeholder="ค้นหาด้วยชื่อสินค้า หรือหมวดหมู่หลัก"
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
          />
          <Box sx={{ mt: 2 }}>
            <DataGrid
              rows={filteredProducts.map((p, idx) => ({
                id: p.id,
                no: idx + 1,
                ...p,
              }))}
              columns={[
                { field: "no", headerName: "ลำดับ", flex: 0, width: 70 },
                { field: "title", headerName: "ชื่อสินค้า", flex: 2 },
                { field: "category", headerName: "หมวดหมู่", flex: 1 },
                { field: "subCategory", headerName: "หมวดหมู่ย่อย", flex: 1 },
                { field: "description", headerName: "คำอธิบาย", flex: 1.5 },
                {
                  field: "price",
                  headerName: "ราคาซื้อทั่วไป",
                  type: "number",
                  flex: 1.5,
                  minWidth: 120,
                  align: "right",
                  headerAlign: "right",
                  renderCell: (params) => {
                    const value = params.value ?? 0;
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          width: "100%",
                          gap: 4,
                        }}
                      >
                        <NumericFormat
                          value={value}
                          displayType="text"
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          renderText={(formattedValue) => (
                            <span>{formattedValue}</span>
                          )}
                        />
                      </div>
                    );
                  },
                },
                {
                  field: "adjustment",
                  headerName: "ราคาเพิ่ม/ลด ต่อหน่วย",
                  type: "number",
                  editable: false,
                  flex: 1.5,
                  align: "right",
                  headerAlign: "right",
                  renderCell: (params) => {
                    const value = params.value ?? 0;
                    const color = value < 0 ? "#f44336" : "#4caf50";
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          width: "100%",
                          gap: 4,
                        }}
                      >
                        <NumericFormat
                          value={value}
                          displayType="text"
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          renderText={(formattedValue) => (
                            <span style={{ color }}>{formattedValue}</span>
                          )}
                        />
                      </div>
                    );
                  },
                },
                {
                  field: "total",
                  headerName: "ราคารวม",
                  type: "number",
                  flex: 1.5,
                  align: "right",
                  headerAlign: "right",
                  renderCell: (params) => {
                    const value = params.value;
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          width: "100%",
                          gap: 4,
                        }}
                      >
                        <NumericFormat
                          value={value}
                          displayType="text"
                          thousandSeparator
                          decimalScale={2}
                          fixedDecimalScale
                          renderText={(formattedValue) => (
                            <span>{formattedValue}</span>
                          )}
                        />
                      </div>
                    );
                  },
                },
              ]}
              editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={setRowModesModel}
              loading={loading}
              pageSizeOptions={[25, 50, 100]}
              initialState={{
                pagination: { paginationModel: { page: 0, pageSize: 25 } },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
